<div id="notification-layout">
  <ul>
    <li class="sp-pb-24 border p-rel">
      <gh-notification-category [icon]="'gh-icon-goal'" [settingKeys]="notificationSettingsMap.okrs" [notificationSettings]="notificationSettings" [categoryNameKey]="'okrs'">
      </gh-notification-category>
      <div class="col-titles-container {{ notificationClass }} space-between-horiz p-abs">
        <span class="col-title">Gtmhub</span>
        <span class="col-title">Email</span>
      </div>
    </li>
    <li class="sp-pb-24 sp-mt-12 border">
      <gh-notification-category [icon]="'gh-icon-metric'" [settingKeys]="notificationSettingsMap.krs" [notificationSettings]="notificationSettings" [categoryNameKey]="'key_result_updates'">
      </gh-notification-category>
    </li>
    <li *ngIf="featureAvailable('kpis') && hasPermission('ManageData')" class="sp-pb-24 sp-mt-12 border">
      <gh-notification-category [icon]="'gh-icon-kpi'" [settingKeys]="notificationSettingsMap.kpis" [notificationSettings]="notificationSettings" [categoryNameKey]="'kpis'">
      </gh-notification-category>
    </li>
    <li *ngIf="featureAvailable('hub.tasks') && !hasRole('view-only')" class="sp-pb-24 sp-mt-12 border">
      <gh-notification-category [icon]="'gh-icon-task'" [settingKeys]="notificationSettingsMap.tasks" [notificationSettings]="notificationSettings" [categoryNameKey]="'tasks'">
      </gh-notification-category>
    </li>
    <li *ngIf="!hasRole('view-only')" class="sp-pb-24 sp-mt-12 border">
      <gh-notification-category [icon]="'gh-icon-badge'" [settingKeys]="notificationSettingsMap.badges" [notificationSettings]="notificationSettings" [categoryNameKey]="'badges'">
      </gh-notification-category>
    </li>
    <!-- TODO: reflections - remove ng-class-border when released -->
    <li class="sp-pb-24 sp-mt-12" [ngClass]="{ border: isReflectionEnabled }">
      <gh-notification-category
        [icon]="'gh-icon-mention'"
        [settingKeys]="notificationSettingsMap.mentionsInComments"
        [notificationSettings]="notificationSettings"
        [categoryNameKey]="'mentions_and_comments_and_reactions'">
      </gh-notification-category>
    </li>
    <li class="sp-mt-12" *ngIf="isReflectionEnabled">
      <gh-notification-category [icon]="'gh-icon-list'" [settingKeys]="notificationSettingsMap.reflections" [notificationSettings]="notificationSettings" [categoryNameKey]="'reflections'">
      </gh-notification-category>
    </li>
  </ul>
</div>
